import {kebabCase} from "lodash/string";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import PurchasingGroupStage1BasicData from "../stage1/panels/basicData/PurchasingGroupStage1BasicData";
import PurchasingGroupStage1Commission from "../stage1/panels/commission/PurchasingGroupStage1Commission";
import PurchasingGroupStage1Schedule from "../stage1/panels/schedule/PurchasingGroupStage1Schedule";
import PurchasingGroupStage1Members from "../stage1/panels/members/PurchasingGroupStage1Members";
import PurchasingGroupStage1PapersGenerator from "../stage1/panels/papersGenerator/PurchasingGroupStage1PapersGenerator";
import PurchasingGroupStage1Opinion from "../stage1/panels/opinion/PurchasingGroupStage1Opinion";
import PurchasingGroupStage1FinishPreparing from "../stage1/panels/finishPreparing/PurchasingGroupStage1FinishPreparing";
import PurchasingGroupStage2Schedule from "../stage2/panels/collectingSchedule/PurchasingGroupStage2Schedule";
import PurchasingGroupStage2Template from "../stage2/panels/template/PurchasingGroupStage2Template";
import PurchasingGroupStage2Dealing from "../stage2/panels/dealing/PurchasingGroupStage2Dealing";
import PurchasingGroupStage2Finish from "../stage2/panels/finish/PurchasingGroupStage2Finish";

export const PurchasingGroupStageSections = {
    //STAGE 1 sections
    STAGE_1_SECTION: "STAGE_1_SECTION",
    BASIC_DATA: "BASIC_DATA",
    COMMISSION: "COMMISSION",
    MEMBERS: "MEMBERS",
    SCHEDULE: "SCHEDULE",
    OPINION: "OPINION",
    FINISH_PREPARING: "FINISH_PREPARING",
    PAPERS_GENERATOR: "PAPERS_GENERATOR",

    //STAGE 2 sections
    STAGE_2_SECTION: "STAGE_2_SECTION",
    SWZ: "SWZ",
    COLLECTING_SCHEDULE: "COLLECTING_SCHEDULE",
    OPINION_SWZ: "OPINION_SWZ",
    TEMPLATE: "TEMPLATE",
    DEALING: "DEALING",
    FINISH: "FINISH",
    COLLECTING_PAPERS_GENERATOR: "COLLECTING_PAPERS_GENERATOR"
}


export const StageSectionNameToSectionParam = Object.keys(PurchasingGroupStageSections).reduce((prev, curr) => {
    prev[curr] = kebabCase(curr);
    return prev;
}, {});

export const StageSectionParamToSectionName = Object.keys(PurchasingGroupStageSections).reduce((prev, curr) => {
    prev[kebabCase(curr)] = curr;
    return prev;
}, {});


export const StageSectionsComponents = {

    BASIC_DATA: PurchasingGroupStage1BasicData,
    COMMISSION: PurchasingGroupStage1Commission,
    MEMBERS: PurchasingGroupStage1Members,
    SCHEDULE: PurchasingGroupStage1Schedule,
    OPINION: PurchasingGroupStage1Opinion,
    FINISH_PREPARING: PurchasingGroupStage1FinishPreparing,
    PAPERS_GENERATOR: PurchasingGroupStage1PapersGenerator,

    SWZ: PurchasingGroupStage1Members,
    COLLECTING_SCHEDULE: PurchasingGroupStage2Schedule,
    OPINION_SWZ: PurchasingGroupStage1Opinion,
    TEMPLATE: PurchasingGroupStage2Template,
    DEALING: PurchasingGroupStage2Dealing,
    FINISH: PurchasingGroupStage2Finish,
    COLLECTING_PAPERS_GENERATOR: PurchasingGroupStage1PapersGenerator
}

export const getSectionVariant = (section) => section ? (section.status === DemandValidationSectionStatus.OK ? 'Done' : (section.status === DemandValidationSectionStatus.DISABLED ? 'Wait' : (section.status === DemandValidationSectionStatus.ERROR ? 'Required' : (section.required ? 'Required' : 'Optional')))) : "Wait";